<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?0db0f6e7